import { uniformStockCode } from '../api/mock';

/**
 * 验证股票代码是否合法
 * @param {string} stockCode - 待验证的股票代码
 * @returns {boolean} 如果是合法的股票代码返回true，否则返回false
 */
export function isValidStockCode(stockCode) {
  if (!stockCode || typeof stockCode !== 'string') {
    return false;
  }

  // 转换为小写以便比较
  const lowerCode = stockCode.toLowerCase().trim();

  // 检查是否包含前缀
  const prefixRegex = /^(sz|sh|zs|hk)\.?(\d+)$/;
  const match = lowerCode.match(prefixRegex);

  if (match) {
    const prefix = match[1];
    const digits = match[2];

    // 根据前缀验证数字位数
    if (prefix === 'hk') {
      return digits.length === 5 && /^\d{5}$/.test(digits);
    } else {
      // sz, sh, zs 前缀要求6位数字
      return digits.length === 6 && /^\d{6}$/.test(digits);
    }
  } else {
    // 没有前缀的情况，检查5位或6位纯数字
    return (lowerCode.length === 5 || lowerCode.length === 6) && /^\d+$/.test(lowerCode);
  }
}

/**
 * 添加股票到监控列表
 * @param {string} stockCode - 股票代码
 * @returns {Object} 包含success和message属性的结果对象
 */
export function addToMonitor(stockCode) {
  if (!stockCode) {
    return { success: false, message: "股票代码不能为空！" };
  }
  
  const codeToAdd = uniformStockCode(stockCode);
  if (!codeToAdd) {
    return { success: false, message: "不支持的股票代码：" + stockCode };
  }
  
  // 从localStorage获取现有监控列表
  let monitoredStocks = [];
  const stocks = localStorage.getItem('monitoredStocks');
  if (stocks) {
    try {
      const stockData = JSON.parse(stocks);
      if (Array.isArray(stockData)) {
        monitoredStocks = stockData;
      }
    } catch (e) {
      console.error("解析监控列表数据出错:", e);
    }
  }
  
  // 检查是否已经存在于监控列表中
  if (monitoredStocks.some(stock => stock.code === codeToAdd)) {
    return { success: false, message: "该股票已在监控列表中！" };
  }
  
  // 初始化alerts为按scale分组的结构
  const alertsByScale = {
    '1': [],
    '5': [],
    '30': [],
    'd': [],
    'w': []
  };
  
  // 添加到监控列表
  monitoredStocks.push({ code: codeToAdd, alerts: alertsByScale, macdColor: null, isPinned: false });
  
  // 保存到localStorage
  try {
    localStorage.setItem('monitoredStocks', JSON.stringify(monitoredStocks));
    return { success: true, message: "已成功添加到监控列表！" };
  } catch (e) {
    console.error("保存监控列表数据出错:", e);
    return { success: false, message: "保存到监控列表失败！" };
  }
}